<template>
  <div class="h-100 w-100">
    <div class="card card-bottom-radius-8">
      <div class="card-header">
        Gestão de Documentos (GDocs)
      </div>
      <div class="card-block">
        <TreeGrid
          ref="treeGrid"
          itemKey="id"
          :load="loadData"
          :loadRelated="loadRelated"
          :hasItems="item => item.possuiConteudo"
        >
          <template #rows>
            <tr class="tree-grid-root-row">
              <td
                colspan="5"
                class="tree-grid-root-column"
              >
              </td>
              <td
                class="tree-grid-root-column"
              >
                <span class="d-flex justify-content-center">
                  <span
                    v-if="hasRole(roles.RW_OPER_GDOCS)"
                    class="pointer"
                    @click="handleAddFolder"
                  >
                    <i class="fas fa-folder-plus fa-lg text-third"/>
                  </span>
                  <span
                    class="pointer mx-1"
                    @click="handleReport(null)"
                  >
                    <i class="fas fa-file-download fa-lg text-third"/>
                  </span>
                </span>
              </td>
            </tr>
          </template>

          <TreeGridColumn title="Nome" field="nome"/>
          <TreeGridColumn title="Caixa/Pasta" field="caixaPasta"/>
          <TreeGridColumn title="Data" field="data">
            <TreeGridAction>
              <template #default="{ item }">
                <span v-if="item.data">{{ item.data ? moment(item.data).format('DD/MM/YYYY') : ' - ' }}</span>
                <span v-else>-</span>
              </template>
            </TreeGridAction>
          </TreeGridColumn>
          <TreeGridColumn title="Validade" field="validade">
            <TreeGridAction>
              <template #default="{ item }">
                <span v-if="item.validade">{{ item.validade ? moment(item.validade).format('DD/MM/YYYY') : ' - ' }}</span>
                <span v-else>-</span>
              </template>
            </TreeGridAction>
          </TreeGridColumn>
          <TreeGridColumn title="Status" field="status">
            <TreeGridAction>
              <template #default="{ item }">
                <span
                  v-if="item.status === 1"
                  class="badge badge-danger text-toupper"
                >
                  Pendente
                </span>

                <span
                  v-else-if="item.status === 2"
                  class="badge badge-success text-toupper"
                >
                  Finalizado
                </span>

                <span v-else>-</span>
              </template>
            </TreeGridAction>
          </TreeGridColumn>
          <TreeGridColumn title="Ações">
            <TreeGridAction>
              <template #default="{ item }">
                <span
                  v-if="item.tipo === 1 && hasRole(roles.RW_OPER_GDOCS)"
                  class="pointer"
                  @click="handleEditFile(item)"
                >
                  <i class="fas fa-file fa-lg text-third"/>
                </span>
                <span
                  v-if="item.tipo === 1 && hasRole(roles.RW_OPER_GDOCS)"
                  class="pointer"
                  @click="handleAddFolder(item)"
                >
                  <i class="fas fa-folder-plus fa-lg text-third"/>
                </span>
                <span
                  v-if="item.tipo === 1 && hasRole(roles.RW_OPER_GDOCS)"
                  class="pointer"
                  @click="handleEditFolder(item)"
                >
                  <i class="fas fa-edit fa-lg text-third"/>
                </span>
                <span
                  v-if="item.tipo === 1 && hasRole(roles.RW_OPER_GDOCS_MOVE)"
                  class="pointer"
                  @click="handleMove(item)"
                >
                  <i class="fas fa-arrows-alt fa-lg text-third"/>
                </span>
                <span
                  v-if="item.tipo === 1 && hasRole(roles.RW_OPER_GDOCS)"
                  :class="canDelete(item) ? 'pointer' : ''"
                  @click="handleDeleteFolder(item)"
                >
                  <i
                    class="fas fa-minus-circle fa-lg"
                    :class="canDelete(item) ? 'text-danger' : 'text-secondary'"
                  />
                </span>
                <span
                    v-if="item.tipo === 1"
                    :class="item.possuiConteudo ? 'pointer' : ''"
                    @click="handleReport(item)"
                  >
                    <i
                      class="fas fa-file-download fa-lg"
                      :class="item.possuiConteudo ? 'text-third' : 'text-secondary'"
                    />
                  </span>

                <span
                  v-if="item.tipo === 2"
                  class="pointer"
                  @click="download(item)"
                >
                  <i class="fas fa-download fa-lg text-third"/>
                </span>

                <span
                  v-if="item.tipo === 2 && canPreview(item)"
                  class="pointer"
                  @click="preview(item)"
                >
                  <i class="fas fa-eye fa-lg text-third"/>
                </span>
                <span
                  v-if="item.tipo === 2 && hasRole(roles.RW_OPER_GDOCS)"
                  class="pointer"
                  @click="handleEditFile(item)"
                >
                  <i class="fas fa-edit fa-lg text-third"/>
                </span>
                <span
                  v-if="item.tipo === 2 && hasRole(roles.RW_OPER_GDOCS_MOVE)"
                  class="pointer"
                  @click="handleMove(item)"
                >
                  <i class="fas fa-arrows-alt fa-lg text-third"/>
                </span>
                <span
                  v-if="item.tipo === 2 && hasRole(roles.RW_OPER_GDOCS)"
                  class="pointer"
                  @click="handleDeleteFile(item)"
                >
                  <i class="fas fa-minus-circle fa-lg text-danger"/>
                </span>
              </template>
            </TreeGridAction>
          </TreeGridColumn>
        </TreeGrid>
      </div>
    </div>

    <AddFolderModal
      ref="folderModal"
      @saved="reload"
    />

    <MoveFolderModal
      ref="moveFolderModal"
      @moved="reload"
    />

    <AddDocumentModal
      ref="documentModal"
      @saved="reload"
      @preview="showPreview($event.item, $event.blob)"
    />

    <b-modal
      id="preview-modal"
      size="xl"
      scrolLabel
      hide-footer
      centered
      @hide="clearPreview"
    >
      <div
        class="row justify-content-center align-items-center h-100"
      >
        <img
          v-if="isImage"
          :src="itemPreview.content"
          style="max-width: 90%; width: auto; height: min-content; max-height: 90%;"
        />
        <vue-pdf-app
          v-else
          class="w-100 h-100"
          :key="itemPreview.id"
          :pdf="itemPreview.content"
          theme="light"
          :config="pdfConfig"
        />
      </div>
    </b-modal>
  </div>
</template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'

import TreeGrid from '@/components/treegrid/TreeGrid.vue'
import TreeGridColumn from '@/components/treegrid/TreeGridColumn.vue'
import TreeGridAction from '@/components/treegrid/TreeGridAction.vue'

import AddFolderModal from './components/AddFolder/AddFolderModal.vue'
import AddDocumentModal from './components/AddDocument/AddDocumentModal.vue'
import MoveFolderModal from './components/MoveFolder/MoveFolderModal.vue'

import DocumentsFolderRepository from '@/shared/http/repositories/business/documentsfolder'
import VuePdfApp from 'vue-pdf-app'
import { loading, toast } from '@/shared/utils/UIHelper'
import 'vue-pdf-app/dist/icons/main.css'

import Roles from '@/shared/utils/roles.js'
import PermissionMixin from '@/store/module/permission/mixin'

const imageFormats = [
  '.JPG',
  '.PNG',
  '.JPEG'
]

const acceptedFormats = [
  ...imageFormats,
  '.PDF'
]

export default {
  name: 'ArchiveDocumentsManagement',
  mixins: [
    ActionsForm,
    PermissionMixin
  ],
  components: {
    TreeGrid,
    TreeGridColumn,
    TreeGridAction,
    AddDocumentModal,
    AddFolderModal,
    MoveFolderModal,
    VuePdfApp
  },
  data () {
    return {
      roles: Roles,
      itemPreview: {
        id: null,
        item: null,
        content: null
      },
      pdfConfig: {
        toolbar: {
          toolbarViewerRight: {
            presentationMode: false,
            openFile: false,
            download: false,
            viewBookmark: false
          },
          toolbarViewerMiddle: {
            zoomOut: true,
            zoomIn: true,
            scaleSelectContainer: true
          }
        },
        secondaryToolbar: {
          secondaryPresentationMode: false,
          secondaryOpenFile: false,
          secondaryPrint: false,
          secondaryDownload: false,
          secondaryViewBookmark: false,
          // firstPage: true,
          // lastPage: true,
          pageRotateCw: true,
          pageRotateCcw: true,
          cursorSelectTool: false,
          cursorHandTool: false,
          scrollVertical: false,
          scrollHorizontal: false,
          scrollWrapped: false,
          spreadNone: false,
          spreadOdd: false,
          spreadEven: false,
          documentProperties: false
        }
      }
    }
  },
  computed: {
    isImage () {
      if (!this.itemPreview || !this.itemPreview.item) return false

      return imageFormats.includes(this.itemPreview.item.formatoArquivo.toUpperCase())
    }
  },
  methods: {
    async loadData () {
      const data = await DocumentsFolderRepository.GetAll(this.CompanySelected)

      return data
    },
    async loadRelated (item) {
      const data = await DocumentsFolderRepository.GetAllInFolder(this.CompanySelected, item.id)

      return data
    },
    async reload (event) {
      if (event && event.item && (event.item.pastaID || event.item.id)) {
        const itemId = event.item.pastaID !== null ? event.item.pastaID : event.item.id
        const index = this.$refs.treeGrid.data.findIndex(item => item.id === itemId)
        const item = this.$refs.treeGrid.data[index]

        this.$refs.treeGrid.reloadItem(item, index)
      } else {
        this.$refs.treeGrid.reload()
      }
    },
    canPreview (item) {
      if (acceptedFormats.includes(item.formatoArquivo.toUpperCase())) {
        return true
      }

      return false
    },
    canDelete (item) {
      return !item.possuiConteudo
    },
    handleAddFolder (item = null) {
      this.$refs.folderModal.show(item, null)
    },
    // Caminho da pasta na arvore ja carregada do TreeGrid: sobe por _parentId ate a raiz.
    // O caminho sempre esta em memoria — pra chegar na pasta o usuario expandiu os pais.
    // Set de visitados protege de ciclo pre-existente na base (a arvore e ponteiro-pai puro).
    folderPath (item) {
      const rows = this.$refs.treeGrid ? this.$refs.treeGrid.data : []
      const names = []
      const seen = new Set()
      let current = item

      while (current && !seen.has(current.id)) {
        seen.add(current.id)
        names.unshift(current.nome)
        current = current._parentId ? rows.find(row => row.id === current._parentId) : null
      }

      return names
    },
    handleMove (item) {
      this.$refs.moveFolderModal.show(item, this.folderPath(item))
    },
    handleEditFolder (item) {
      const folder = {
        id: item.id,
        empresaID: this.CompanySelected,
        pastaPaiID: item.pastaID,
        nome: item.nome,
        caixaPasta: item.caixaPasta
      }

      this.$refs.folderModal.show(item, folder)
    },
    handleEditFile (item) {
      const folder = {
        id: item.tipo === 1 ? item.id : item.pastaID
      }

      const document = item.tipo === 1 ? null : item

      this.$refs.documentModal.show(folder, document, item)
    },
    async handleDeleteFile (item) {
      this.createMsgBox(this.$lang.Common.ConfirmDelete)
        .then(async (accepted) => {
          if (accepted) {
            loading.push()

            await DocumentsFolderRepository.DeleteDocument(item.pastaID, item.id)
              .then(response => {
                if (response.data.code >= 0) {
                  toast.success(this.$lang.Common.Alerts.Success)
                } else {
                  toast.error(response.data.message)
                }

                this.$nextTick(() => {
                  this.reload({ item })
                  loading.close()
                })
              })
              .catch(err => {
                console.log(err)
              })
          }
        })
    },
    async handleDeleteFolder (item) {
      if (!this.canDelete(item)) return

      this.createMsgBox(this.$lang.Common.ConfirmDelete)
        .then(async (accepted) => {
          if (accepted) {
            loading.push()

            await DocumentsFolderRepository.DeleteFolder(item.id)
              .then(response => {
                if (response.data.code >= 0) {
                  toast.success(this.$lang.Common.Alerts.Success)
                } else {
                  toast.error(response.data.message)
                }

                this.$nextTick(() => {
                  this.reload({ item })
                  loading.close()
                })
              })
              .catch(err => {
                console.log(err)
              })
          }
        })
    },
    handleReport (item = null) {
      if (item === null || (item && item.possuiConteudo)) {
        const params = {}

        if (item !== null) params.pastaID = item.id

        return DocumentsFolderRepository.GetReport(this.CompanySelected, {
          params,
          responseType: 'blob'
        })
          .then(response => {
            const href = URL.createObjectURL(response.data)
            const fileName = `relatorio-gdocs-${this.moment().format('DD/MM/YYYY')}`
            const link = document.createElement('a')

            link.href = href
            link.setAttribute('download', `${fileName}.xlsx`)

            document.body.appendChild(link)
            link.click()

            document.body.removeChild(link)
            URL.revokeObjectURL(href)
          })
      }
    },
    getDocumentFile (item) {
      return DocumentsFolderRepository.GetDocumentFile(this.CompanySelected, item.id, {
        responseType: 'arraybuffer'
      })
        .then(response => {
          return response.data
        })
    },
    async preview (item) {
      const documentBlob = await this.getDocumentFile(item)
      const format = item.formatoArquivo.toUpperCase()
      const contentType = imageFormats.includes(format) ? 'image/png' : 'application/pdf'

      const blob = new Blob([documentBlob], { type: contentType })
      await this.showPreview(item, blob)
    },
    async showPreview (item, blob) {
      this.itemPreview.id = item.id
      this.itemPreview.item = item
      this.itemPreview.content = await this.blobToBase64(blob)
      this.$bvModal.show('preview-modal')
    },
    clearPreview () {
      this.itemPreview.id = null
      this.itemPreview.item = null
      this.itemPreview.content = null
    },
    blobToBase64 (blob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onloadend = () => resolve(reader.result)
        reader.readAsDataURL(blob)
      })
    },
    async download (item) {
      const documentBlob = await this.getDocumentFile(item)
      const blob = new Blob([documentBlob])
      const href = URL.createObjectURL(blob)

      const link = document.createElement('a')
      link.href = href
      link.setAttribute('download', item.nomeArquivo + item.formatoArquivo)

      document.body.appendChild(link)

      link.click()

      document.body.removeChild(link)
      URL.revokeObjectURL(href)
    },
    createMsgBox (msg) {
      const h = this.$createElement
      let messageVNode = h('div', [
        h('h4', [
          this.$lang.Common.LabelConfirmation
        ]),
        h('br')
      ])

      return this.$bvModal.msgBoxConfirm([messageVNode], {
        title: msg,
        centered: true,
        okTitle: this.$lang.Common.Yes,
        cancelTitle: this.$lang.Common.No,
        headerClass: 'justify-content-center'
      })
    }
  }
}
</script>

<style scoped>
.tree-grid-root-row {
  background-color: rgb(238, 238, 238);
}

.tree-grid-root-column {
  height: 22px;
  padding: 0.2rem 0.75rem !important;
}

* >>> div#preview-modal .modal-dialog .modal-content {
  position: absolute;
  height: 100%;
}

* >>> .modal-body {
  padding-top: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/private/archiveDocumentsManagement/ArchiveDocumentsManagement.vue